import * as React from 'react';
import './checkout.css';
// import Button from '../custom_components/button/button.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { Signup_Obj } from '../store/reducers/signup_input.reducers';
import { connect } from 'react-redux';
// import { withRouter } from 'react-router';
import { History } from 'history';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';
import { Checkout_Obj, Checkout_Stage_Obj } from '../store/reducers/checkout_stage.reducers';
// import Button from '../custom_components/button/button.component';

import CheckoutForm from './form/checkoutForm';
import { StripeProvider, Elements } from 'react-stripe-elements';

// import Button from '../custom_components/button/button.component';

export interface CheckoutD_Props {
    signup_form: Signup_Obj;
    signup_details: Signup_Details_Obj;
    checkout: Checkout_Obj;
    checkout_stage: Checkout_Stage_Obj;

    updateForm: Function;
    updateStage: Function;
}

export interface Country_Obj {
    name: string;
    short_name: string;
    code: string;
}

class CheckoutD extends React.PureComponent<CheckoutD_Props> {

    render() {

        return (
            <div className="checkout-cta">
                <span className="checkout-cta-title">{this.props.checkout.title_text}</span>
                <div className="checkout-cta-text-box">
                    <span className="checkout-cta-sub-title">{this.props.checkout.sub_title_text}</span>
                </div>
                <div className="checkout-signup-form-c">
                    {/* <div className="checkout-cta-text-box-total">
                        <span className="checkout-cta-total-title">Total Amount: 
                        {this.props.signup_details.product != null ? (' ' + this.props.signup_details.product.currency + this.roundNumber((this.props.signup_details.product.price_monthly * 12) + (((this.props.signup_details.device_add_quantity != undefined) ? this.props.signup_details.device_add_quantity : 0) * 450))) : '$0.00'} / year</span>
                    </div> */}
                    <StripeProvider apiKey="pk_live_g5YzDFOWjCPLWgNgOwH2F8Ti">
                        <div className="stripe-container">
                        <Elements>
                            <CheckoutForm checkout={this.props.checkout} />
                        </Elements>
                        </div>
                    </StripeProvider>
                </div>
            </div>
        )
    }

    emailInput = (event: any) => {
        let re = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        
        let email_validity: boolean = re.test(event.target.value);
        
        let updated_form: Signup_Obj = {
            value: event.target.value,
            valid: email_validity
        }
        this.props.updateForm('SIGNUP_UPDATE', updated_form)

        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            email: event.target.value
        };

        if (email_validity) {
            this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)
        }

        this.validateCheckoutForm(fresh_details, email_validity)
    }

    formInput = (field_name: string, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            [field_name]: event.target.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        this.validateCheckoutForm(fresh_details, this.props.signup_form.valid)
    }

    validateCheckoutForm = (fresh_details: Signup_Details_Obj, email_validity: boolean) => {
        if (fresh_details.country != '' && fresh_details.city != '' && fresh_details.street_name != '') {
            let updated_checkout: Checkout_Stage_Obj = {
                ...this.props.checkout_stage,
                [this.props.checkout.id]: {
                    ...this.props.checkout_stage[this.props.checkout.id],
                    form_valid: true
                }
            }

            this.props.updateStage('CHECKOUT_UPDATE', updated_checkout)
        } else {
            let updated_checkout: Checkout_Stage_Obj = {
                ...this.props.checkout_stage,
                [this.props.checkout.id]: {
                    ...this.props.checkout_stage[this.props.checkout.id],
                    form_valid: false
                }
            }

            this.props.updateStage('CHECKOUT_UPDATE', updated_checkout)
        }
    }

    submitForm = (history: History, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            ...this.props.signup_details,
            email: this.props.signup_form.value
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/pricing')
    }

    previousStage = () => {
        this.props.updateStage('CHECKOUT_STAGE_UPDATE', {stage: '1'})
    }

    roundNumber = (number: number) => {
        return (parseFloat('' + number).toFixed(2));
    }

}

export function mapStateToProps({ signup_form, signup_details, checkout_stage }: StoreState) {
    return {
      signup_form: signup_form,
      signup_details: signup_details,
      checkout_stage: checkout_stage
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateForm: selectGeneric,
        updateStage: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutD);


// WEBPACK FOOTER //
// ./src/checkout/checkout_d.component.tsx